/**
 * app/js/modules/FakeDateChooser.js
 *
 * @author Johannes Braun <johannes.braun@swu.de>
 * @package aktionskalender
 * @version 2024-04-30
 */
export default class FakeDateChooser extends HTMLElement {

    constructor() {
        super();

        // Get the template content
        const template = document
            .getElementById("fake-date-chooser-template")
            .content.cloneNode(true);
        this.attachShadow({ mode: 'open' }).appendChild(template);

        this.form = this.shadowRoot.querySelector('form');
        this.dateInput = this.shadowRoot.querySelector('input[type=date]');
        this.dateInput.setAttribute('min', this.getAttribute('min'));
        this.dateInput.setAttribute('max', this.getAttribute('max'));
        this.dateInput.value = this.getAttribute('value');

        this.label = this.shadowRoot.querySelector('span');
        const fakeDate = new Date(this.getAttribute('value'));
        this.label.innerText = `${fakeDate.getDate()}.${fakeDate.getMonth() + 1}.`; //new Date(this.getAttribute('value')).toLocaleDateString();

        this.triggerBtn = this.shadowRoot.querySelector('.trigger-btn');
        this.triggerBtn.addEventListener('click', e => this.onTriggerClicked(e));

        this.content = this.shadowRoot.querySelector('.content');
        this.iconCalendar = this.shadowRoot.querySelector('.icon--calendar');
        this.iconCross = this.shadowRoot.querySelector('.icon--cross');

        this.cb = this.shadowRoot.querySelector('[name=constrain]')
        this.min = this.dateInput.getAttribute('min');
        this.max = this.dateInput.getAttribute('max');
        this.cb.onchange = e => this.updateMinMaxAttr();
        this.updateMinMaxAttr();

        this.prevBtn = this.shadowRoot.querySelector('button.prev');
        this.nextBtn = this.shadowRoot.querySelector('button.next');
        this.prevBtn.onclick = e => {
            e.preventDefault();
            this.addDays(-1);
        }
        this.nextBtn.onclick = e => {
            e.preventDefault();
            this.addDays(1);
        }
        // this.dateInput.onchange = e => {
        //     this.form.submit();
        // };
    }

    addDays(n) {
        var d = new Date(this.dateInput.value);
        d.setDate(d.getDate() + n);
        console.log(d.toISOString().split('T')[0]);
        this.dateInput.value = d.toISOString().split('T')[0];
    }

    updateMinMaxAttr() {
        if (this.cb.checked) {
            this.dateInput.setAttribute('min', this.min);
            this.dateInput.setAttribute('max', this.max);
        }
        else {
            this.dateInput.removeAttribute('min');
            this.dateInput.removeAttribute('max');
        }
    }



    onTriggerClicked(event) {
        event.preventDefault();
        this.form.toggleAttribute('open');
        // this.form.toggleAttribute('hidden');
        this.content.toggleAttribute('hidden');
        this.iconCalendar.toggleAttribute('hidden');
        this.iconCross.toggleAttribute('hidden');

    }
}
customElements.define("fake-date-chooser", FakeDateChooser);

// This is a basic boilerplate code for creating a custom element in JavaScript.
// Custom elements are a feature of the Web Components API that allows
// developers to create their own HTML elements with custom functionality. This
// boilerplate code provides a starting point for creating a custom element and
// can be customized to fit your specific needs.
//
// HTML:
//
// ```
// <template id="custom-element-template">
//   <!-- HTML markup for your custom element -->
// </template>
//
// <custom-element></custom-element>
// ```
//
// JavaScript:
//
// ```
// // Define the custom element class
// class CustomElement extends HTMLElement {
//   constructor() {
//     super();
//
//     // Get the template content
//     const template = document
//       .getElementById("custom-element-template")
//       .content.cloneNode(true);
//
//     // Attach the shadow root to the element
//     this.attachShadow({ mode: "open" }).appendChild(template);
//
//     // Add event listeners or other functionality here
//   }
// }
//
// // Define the custom element tag
// customElements.define("custom-element", CustomElement);
// ```
//
// CSS:
//
// ```
// /* Styles for your custom element */
// custom-element {
//   /* CSS styles here */
// }
// ```
//
// To use this boilerplate code, simply copy and paste it into your project and
// customize it to fit your needs. You can add event listeners, methods, and other
// functionality to the custom element class to make it more dynamic and
// interactive. You can also add CSS styles to the custom element to give it a
// unique look and feel.
//
// Remember to always use unique names for your custom element tag and class to
// avoid conflicts with other elements on the page. You can also add attributes to
// your custom element and access them in the JavaScript code using the
// `getAttribute()` method.
//
// For more information on custom elements and Web Components, check out the
// official documentation on MDN or other online resources. Happy coding!
